import React from 'react';
import { Mail, Phone, Award } from 'lucide-react';
import { Button } from './ui/button';
import { profileData } from '../data/mock';

const Hero = () => {
  const scrollToContact = (e) => {
    e.preventDefault();
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="pt-20 min-h-screen flex items-center bg-gradient-to-br from-slate-50 to-gray-100">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="inline-flex items-center px-4 py-2 bg-amber-100 rounded-full">
              <Award className="w-5 h-5 text-amber-600 mr-2" />
              <span className="text-sm font-semibold text-amber-800">{profileData.experience} of Excellence</span>
            </div>
            
            <div>
              <h1 className="text-5xl lg:text-6xl font-bold text-slate-800 mb-4 leading-tight">
                {profileData.name}
              </h1>
              <p className="text-xl text-gray-600 mb-6">
                {profileData.tagline}
              </p>
            </div>

            <p className="text-lg text-gray-700 leading-relaxed">
              {profileData.description}
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                onClick={scrollToContact}
                size="lg"
                className="bg-amber-600 hover:bg-amber-700 text-white text-lg px-8"
              >
                Schedule Consultation
              </Button>
              <a href="#expertise">
                <Button
                  size="lg"
                  variant="outline"
                  className="border-2 border-slate-700 text-slate-700 hover:bg-slate-700 hover:text-white text-lg px-8"
                >
                  View Expertise
                </Button>
              </a>
            </div>

            <div className="flex flex-col sm:flex-row gap-6 pt-4">
              <a
                href={`mailto:${profileData.email}`}
                className="flex items-center text-gray-700 hover:text-amber-600 transition-colors"
              >
                <Mail className="w-5 h-5 mr-2" />
                <span className="font-medium">{profileData.email}</span>
              </a>
              <a
                href={`tel:${profileData.phone}`}
                className="flex items-center text-gray-700 hover:text-amber-600 transition-colors"
              >
                <Phone className="w-5 h-5 mr-2" />
                <span className="font-medium">{profileData.phone}</span>
              </a>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={profileData.heroImage}
                alt="CA Sanjay Kumar Agrawal"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/20 to-transparent"></div>
            </div>
            {/* Decorative Elements */}
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-amber-200 rounded-full blur-3xl opacity-50"></div>
            <div className="absolute -bottom-6 -left-6 w-40 h-40 bg-slate-200 rounded-full blur-3xl opacity-50"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;